export const QUERY_KEYS = {
  ACTIVITIES: 'activities',
  ACTIVITY: 'activity',
  CLASSES: 'classes',
  CLASS: 'class',
  CLASS_STUDENTS: 'classStudents',
  CLASS_TASKS: 'classTasks',
  CLASS_GAMIFICATION_PROGRESS: 'classGamificationProgress',
  CLASSES_PROGRESS: 'classesProgress',
  CLASS_ENROLLMENT_CODE: 'classEnrollmentCode',
  CLASS_THEMES: 'classThemes',
  DASHBOARD_ACTIVITIES: 'dashboardActivities',
  RECOMMENDED_ACTIVITIES: 'recommendedActivities',
  EXTERNAL_CLASSES: 'externalClasses',
  JOB: 'job',
  ME: 'me',
  MILESTONES: 'milestones',
  STUDENTS: 'students',
  STUDENT: 'student',
  STUDENT_CLASS_HISTORY: 'studentClassHistory',
  STUDENT_CLASSES: 'studentClasses',
  SUBSCRIPTION: 'subscription',
  TASK_TEMPLATE: 'taskTemplate',
  TASK_TEMPLATES: 'taskTemplates',
  TASK_ACTIVITIES_STUDENT_PROGRESS: 'taskActivitiesStudentProgress',
  TASKS: 'tasks',
  TASK_PROGRESS: 'taskProgress',
  THEMES: 'themes',
  ADMIN_THEMES: 'adminThemes',
  FAVOURITES: 'favourites',
  STUDENT_TASKS: 'studentTasks',
  STUDENT_TASK_DETAIL: 'studentTaskDetail',
  SUBSCRIPTION_TYPES: 'subscriptionTypes',
  SURVEYS: 'surveys',
  SHARED_STUDENT: 'sharedStudent',
  FEATURE_FLAGS: 'featureFlags',
  CHECK_PROMOTION_CODE: 'checkPromotionCode',
  PAYMENT_METHODS: 'paymentMethods',
  PAYMENT_INTENT: 'paymentIntent',
  STRIPE_COUNTRIES: 'stripeCountries',
  SUBSCRIPTION_PAYMENT_STATUS: 'subscriptionPaymentStatus',
  STRIPE_PRORATION_PREVIEW: 'stripeProrationPreview',
  STRIPE_UPCOMING_INVOICE: 'stripeUpcomingInvoice',
  ADMIN_TASK_TEMPLATES: 'adminTaskTemplates',
  ADMIN_TASK_TEMPLATES_SEQUENCES: 'adminTaskTemplatesSequences',
  EXTERNAL_INSTRUCTION_ACTIVITY: 'externalInstructionActivity',
  REINFORCEMENT_ACTIVITY_DATA: 'reinforcementActivityData',
  CLEVER_DISTRICTS: 'cleverDistricts',
  DISTRICT_TEACHERS: 'districtTeachers',
  COMMUNITY_SESSION: 'communitySession',
};
